module.exports = __webpack_public_path__ + "static/media/cubes.48483f67.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/cubes.png
// module id = 1762
// module chunks = 0